import Enum from '../base/Enum';

export default class ErrorReason extends Enum {
  static driverAlreadyCreated = new ErrorReason('DRIVER_ALREADY_CREATED');
  static emailDoesNotMatch = new ErrorReason('EMAIL_DOES_NOT_MATCH');
  static expiredCoupon = new ErrorReason('EXPIRED_COUPON');
  static invalidCouponCode = new ErrorReason('INVALID_COUPON_CODE');
  static unknown = new ErrorReason('UNKNOWN');
}
